{
  "daytime": {
    "earlier": "Earlier",
    "later": "Later"
  },
  "login": {
    "title": "Login",
    "text": "Login to your account",
    "button": "Login",
    "stressLevel": "Stress Level",
    "errorDialog": {
      "message": "Incorrect username or password!",
      "accept": "Ok"
    },
    "placeholder": {
      "username": "Please enter your username",
      "password": "Please enter your password"
    },
    "passkey": {
      "button": "Login with a passkey"
    }
  },
  "sidebar": {
    "bulletins": "Avalanche.report",
    "dangerSources": "Danger Sources",
    "observations": "Observations",
    "incidents": "Incidents",
    "qfa": "QFA",
    "modelling": "Modelling",
    "modellingForecast": "Forecast",
    "modellingZamg": "ZAMG multi model",
    "modellingZamgECMWF": "ZAMG ECMWF-EPS",
    "modellingZamgCLAEF": "ZAMG CLAEF-EPS",
    "modellingZamgMeteogram": "GeoSphere meteogram",
    "modellingSnowpack": "SNOWPACK model",
    "modellingSnowpackMeteo": "SNOWPACK modelled meteo",
    "awsome": "AWSOME",
    "snowpack": "SNOWPACK",
    "geosphere": "GeoSphere",
    "lineaexport": "LINEA",
    "awsstats": "AWS Stats",
    "yearlystats": "Yearly Stats",
    "graphics": "Graphics",
    "icon": "Weather"
  },
  "weather": {
    "loading": "Loading weather parameters and images...",
    "noPng": "Image not found.",
    "error": {
      "noParameters": "No forecast parameters available.",
      "loadFailed": "Could not load forecast data."
    },
    "headings": {
      "model": "Model",
      "modelRun": "Model run",
      "region": "Region",
      "parameters": "Parameters",
      "level": "Level"
    },
    "alt": {
      "fallback": "Forecast map",
      "image": "{{model}} {{parameter}}{{level}} {{region}} {{date}} {{hour}}Z"
    },
    "models": {
      "icon": "ICON",
      "gfs": "GFS"
    },
    "regions": {
      "atlantic": "Atlantic",
      "europe": "Europe",
      "alps": "Alps",
      "euregio": "EUREGIO"
    },
    "levels": {
      "surface": "Surface",
      "cloudTotal": "Total",
      "cloudHigh": "High",
      "cloudMid": "Mid",
      "cloudLow": "Low"
    },
    "tooltips": {
      "levelApproxElevation": "Approx. elevation: ~{{height}} m"
    },
    "parameters": {
      "gfs": {
        "equivalentPotentialTemp": "Equivalent Potential Temp.",
        "relativeHumidity": "Relative Humidity",
        "geopotentialAndIsotachs": "Geopotential and Isotachs",
        "precipitation": "Precipitation",
        "cape": "CAPE"
      },
      "icon": {
        "cloudCover": "Cloud Cover",
        "ns": "Precipitation 1h",
        "ns24": "Precipitation 24h",
        "nsacc": "Acc. Precipitation",
        "nsprob24gt20": "Prob. Prec. > 20 mm / 24h",
        "nsprob24gt40": "Prob. Prec. > 40 mm / 24h",
        "nsprob24gt80": "Prob. Prec. > 80 mm / 24h",
        "d2m": "Dew Point 2m",
        "gust": "Max. Wind Gust 10m",
        "cape": "MU-CAPE"
      }
    }
  },
  "menu": {
    "logout": "Logout",
    "language": "Language",
    "en": "English",
    "de": "German",
    "fr": "French",
    "it": "Italian",
    "es": "Spanish",
    "ca": "Catalan",
    "oc": "Aranese",
    "fullscreen": "Fullscreen",
    "settings": "Settings",
    "statistics": "Statistics",
    "admin": "Admin",
    "region": "Region",
    "education": "Education"
  },
  "matrix": {
    "label": {
      "snowpackStability": "Snowpack Stability",
      "frequency": "Frequency",
      "avalancheSize": "Avalanche Size",
      "dangerRating": "Danger Rating",
      "override": "(override danger rating)",
      "matrix": "Matrix",
      "referToFairStability": "Refer to fair stability",
      "referToPoorStability": "Refer to poor stability",
      "dangerLevel1": "Danger level 1 (Low)"
    }
  },
  "dangerSources": {
    "status": {
      "missing": "missing",
      "available": "available",
      "forecast": "forecast",
      "analysis": "analysis",
      "loading": "Loading danger sources ...",
      "saveError": "Danger source could not be saved!",
      "loadDangerSourcesError": "Danger sources could not be loaded!",
      "loadVariantsError": "Danger source variants could not be loaded!",
      "noTitle": "<no title>"
    },
    "variantStatus": {
      "active": "active",
      "dormant": "dormant",
      "inactive": "inactive"
    },
    "tooltip": {
      "read": "Read danger sources",
      "edit": "Edit danger sources"
    },
    "table": {
      "loadMore": "Load {{count}} more days",
      "title": {
        "forecast": "Forecast",
        "analysis": "Analysis"
      }
    },
    "create": {
      "variantStatus": "Status",
      "variantEditable": "This variant can be edited.",
      "variantNotEditable": "This variant can not be edited.",
      "noVariantsForSelectedDay": "No variants defined for this date.",
      "tooltip": {
        "editDangerSource": "Edit danger source",
        "loadVariants": "Load variants from the day before",
        "loadVariantsFromForecast": "Load variants from forecast",
        "showVariantsOnMap": "Show variants on map",
        "edit": "Edit micro regions",
        "copy": "Copy variant",
        "delete": "Delete variant",
        "compare": "Compare variant",
        "forecast": "Compare with forecast"
      },
      "createDangerSource": "Create danger source",
      "createVariant": "Create new variant",
      "noDangerSources": "No danger sources",
      "title": {
        "slab": "Slab",
        "weakLayer": "Weak layer",
        "loose": "Loose snow",
        "glide": "Glide snow",
        "matrix": "Matrix",
        "characteristics": "Characteristics",
        "comment": "Comment",
        "uncertainties": "Uncertainties"
      },
      "label": {
        "glidingSnowActivity": "Gliding snow activity",
        "snowHeight": "Snow height",
        "snowHeightLowerLimit": "Min snow height",
        "snowHeightUpperLimit": "Max snow height",
        "snowHeightAverage": "Average snow height",
        "zeroDegreeIsotherm": "0°C isotherm",
        "looseSnowMoisture": "Loose snow moisture",
        "looseSnowGrainShape": "Loose snow grain shape",
        "slabGrainShape": "Slab grain shape",
        "slabThickness": "Slab thickness",
        "slabThicknessLowerLimit": "Min slab thickness",
        "slabThicknessUpperLimit": "Max slab thickness",
        "slabHandHardness": "Slab hand hardness",
        "slabHandHardnessLowerLimit": "Min slab hand hardness",
        "slabHandHardnessUpperLimit": "Max slab hand hardness",
        "slabHardnessProfile": "Slab hardness",
        "slabEnergyTransferPotential": "Slab energy transfer potential",
        "slabDistribution": "Slab distribution",
        "weakLayerGrainShape": "Weak layer grain shape",
        "weakLayerGrainShapes": "Weak layer grain shapes",
        "weakLayerGrainSize": "Weak layer grain size",
        "weakLayerGrainSizeLowerLimit": "Min weak layer grain size",
        "weakLayerGrainSizeUpperLimit": "Max weak layer grain size",
        "weakLayerPersistent": "Weak layer persistent",
        "weakLayerThickness": "Weak layer thickness",
        "weakLayerStrength": "Weak layer strength",
        "weakLayerWet": "Weak layer wet",
        "weakLayerCrustAbove": "Weak layer crust above",
        "weakLayerCrustBelow": "Weak layer crust below",
        "weakLayerPosition": "Weak layer position",
        "weakLayerCreation": "Weak layer creation",
        "weakLayerDistribution": "Weak layer distribution",
        "dangerSpotRecognizability": "Danger spot recognizability",
        "remoteTriggering": "Remote triggering",
        "hasDaytimeDependency": "Daytime dependency",
        "dangerIncreaseWithElevation": "Danger increase with elevation",
        "runoutIntoGreen": "Runout into green",
        "penetrateDeepLayers": "Penetrate deep layers",
        "highestDangerAspect": "Highest danger aspect",
        "dangerPeak": "Danger peak",
        "slopeGradient": "Slope gradient",
        "naturalRelease": "Natural release",
        "terrainTypes": "Terrain types",
        "dangerSigns": "Danger signs",
        "aspects": "Aspects"
      },
      "createDangerSourceDialog": {
        "title": "Title",
        "description": "Description",
        "save": "Save",
        "cancel": "Cancel"
      },
      "editDangerSourceDialog": {
        "title": "Title",
        "description": "Description",
        "update": "Update",
        "cancel": "Cancel"
      },
      "deleteVariantDialog": {
        "message": "Do you want to delete this variant?",
        "accept": "Yes",
        "reject": "No"
      },
      "noRegionDialog": {
        "message": "At least one micro-region has to be yours.",
        "accept": "Ok"
      },
      "discardDialog": {
        "message": "Do you want to discard the changes?",
        "accept": "Yes",
        "reject": "No"
      },
      "saveErrorDialog": {
        "message": "There was an error saving the danger sources!",
        "accept": "Ok"
      },
      "loadDialog": {
        "message": "Do you want to load all danger source variants from the day before?<br><strong>Existing analysis variants will be overwritten.</strong>",
        "accept": "Yes",
        "reject": "No"
      },
      "loadFromForecastDialog": {
        "message": "Do you want to load all variants from the forecast?<br><strong>Existing analysis variants will be overwritten.</strong>",
        "accept": "Yes",
        "reject": "No"
      }
    }
  },
  "avalancheType": {
    "title": "Avalanche type",
    "slab": "slab",
    "loose": "loose",
    "glide": "glide",
    "cornice": "cornice",
    "unknown": "unknown",
    "label": {
      "slab": "SLAB",
      "loose": "LOOSE",
      "glide": "GLIDE"
    },
    "tooltip": {
      "slab": "Slab avalanche",
      "loose": "Loose snow avalanche",
      "glide": "Glide snow avalanche"
    }
  },
  "elevation": {
    "title": "Elevation",
    "high": "Below",
    "low": "Above",
    "treeline": "Treeline"
  },
  "bulletins": {
    "title": "Avalanche.report",
    "tooltip": {
      "edit": "Edit bulletin",
      "read": "Read bulletin",
      "copy": "Copy bulletin",
      "paste": "Paste bulletin",
      "cancel": "Cancel copy",
      "update": "Edit",
      "submit": "Submit",
      "submitUpdate": "Submit update",
      "publishChange": "Publish now (no messages)",
      "publishUpdate": "Publish now",
      "publishMinimal": "Minimal publication",
      "caaml": "Show CAAML",
      "json": "Show JSON",
      "create": "Create bulletin",
      "preview": "Preview bulletin (PDF)",
      "check": "Check bulletin",
      "info": "Show publication status",
      "loadSuggestionFromDangerSources": "Load suggestion from danger sources",
      "deleteAllWarningRegions": "Delete all warning regions",
      "publishAll": "Publish all regions",
      "publishAllNoMessages": "Publish all regions (no messages)",
      "mediaFile": "Upload media file",
      "publicationChecklist": "Open publication checklist"
    },
    "publicationChecklist": {
      "title": "Publication checklist",
      "description": {
        "website": "The map on the website shows the danger levels with their corresponding colors. Clicking on a region shows the avalanche problems and texts.",
        "email": "An email was sent and contains a report.",
        "telegram": "A message containing a link to the website was posted.",
        "whatsapp": "A message containing a link to the website was posted."
      },
      "ok": "Ok",
      "problem": "Problem",
      "problemDescription": "Problem description",
      "problemPlaceholder": "Describe the encountered problem",
      "channel": {
        "website": "Website",
        "whatsapp": "WhatsApp",
        "telegram": "Telegram",
        "email": "Email"
      },
      "publicationInProgress": "Publication in progress",
      "publicationFinishedOnServer": "Finished publication on server",
      "publishDisabled": {
        "inProgress": "Publication is currently in progress.",
        "wrongStatus": "The bulletin must be submitted or published."
      },
      "emailWaitHint": "Email delivery usually takes longer than social media messages. At least 5 minutes should have passed since publication before you proceed to the next step.",
      "email": {
        "waitTitle": "Wait:"
      },
      "options": "Options",
      "republish": "Republish:",
      "resend": "Resend:",
      "website": {
        "checkInternetTitle": "Check internet connection:",
        "checkInternetDescriptionPrefix": "How is the internet connection on your device? Open",
        "checkInternetDescriptionSuffix": "in a private window. Is yesterday's bulletin displayed correctly?",
        "republishHint": "Only perform this step if “Check internet connection” was successful and at least 5 minutes have passed since the last publication attempt.",
        "publishMinimalTitle": "Minimal publication:",
        "publishMinimalHint": "Use this as a fallback if the full publication fails. Publishes CAAML data only — no maps, text-to-speech, or push messages. ⚠️ Also affects other regions on this server, not just your own. All will be republished in minimal mode.",
        "editAndResendTitle": "Edit and resend:",
        "openBulletin": "Open the bulletin",
        "clickEdit": "Click “Edit”",
        "clickSubmit": "Click “Submit”",
        "clickPublishNow": "Click “Publish now”"
      },
      "manualSend": {
        "title": "Manual send:",
        "description": {
          "telegram": "Copy the text below and send it to the specified Telegram group.",
          "whatsapp": "Copy the text below to the specified WhatsApp channel."
        },
        "copyText": "Copy {{language}} {{channel}} text"
      },
      "newChecklist": "New checklist",
      "savedInfo": "Saved by {{user}}, {{time}}",
      "print": {
        "contact": {
          "title": "Emergency contact",
          "emailLabel": "Email:",
          "nameLabel": "Name:",
          "phoneLabel": "Phone:"
        },
        "emergencyTitle": "If serious problems occur",
        "fallback": {
          "title": "Use fallback instance:",
          "step1": "Navigate to the fallback Admin-GUI and publish the bulletin there.",
          "step2": "Manually send messages to subscribed channels. Use the text below:",
          "step3": "Inform the public by creating social media posts linking to the fallback website URL.",
          "step4": "Inform the PR department about the situation."
        },
        "hide": "Hide print version",
        "hint": "Fill in the hosting service contact details and the fallback URLs below, then click \"Print\".",
        "hostingDescription": "Ask about server status. If applicable, request a server restart.",
        "hostingTitle": "Contact hosting service:",
        "print": "Print",
        "toggle": "Print version"
      }
    },
    "status": {
      "submittedInfo": "Will be published at 5PM",
      "resubmittedInfo": "Will be published at 8AM",
      "publishedInfo": "Has been published",
      "noPublicationInfo": "Will NOT be published automatically",
      "loadingPreview": "Creating PDF preview ...",
      "loading": "Loading bulletin ...",
      "loadMoreBulletins": "Load {{count}} more bulletins",
      "publishing": "Publishing bulletin ...",
      "submitting": "Submitting bulletin ...",
      "saveError": "Bulletin could not be saved!",
      "loadBulletinsError": "Bulletins could not be loaded!"
    },
    "create": {
      "tooltip": {
        "edit": "Edit micro regions",
        "copy": "Copy region",
        "delete": "Delete region",
        "deleteProblem": "Delete problem",
        "compare": "Compare region",
        "undo": "Undo last change in region",
        "redo": "Redo change in region",
        "createRegion": "Create region",
        "cancel": "Cancel",
        "acceptSuggestion": "Accept suggested regions",
        "rejectSuggestion": "Decline suggested regions",
        "saveChanges": "Save changes",
        "discardChanges": "Discard changes",
        "incompleteAvalancheProblem": "Incomplete avalanche problem",
        "saveBulletin": "Save bulletin",
        "discardBulletin": "Discard bulletin changes",
        "loadBulletin": "Load bulletin from the day before",
        "uploadCaamlBulletin": "Upload bulletin in CAAML format",
        "uploadJsonBulletin": "Upload bulletin in JSON format",
        "downloadCaamlBulletin": "Download bulletin in CAAML format",
        "downloadJsonBulletin": "Download bulletin in JSON format",
        "daytimeDependency": "Daytime dependency",
        "treeline": "Treeline",
        "tendency": {
          "decreasing": "Avalanche danger decreases",
          "steady": "Avalanche danger stays the same",
          "increasing": "Avalanche danger increases",
          "danger": "Avalanche danger"
        },
        "textcat": {
          "edit": "Edit",
          "copy": "Copy",
          "paste": "Paste",
          "example": "Load example text",
          "delete": "Delete"
        },
        "moveUpAvalancheProblem": "Move avalanche problem up",
        "moveDownAvalancheProblem": "Move avalanche problem down",
        "dangerRatingDirectionUp": "Upwards",
        "dangerRatingDirectionDown": "Downwards",
        "addPhoto": "Add photo",
        "removePhoto": "Remove photo",
        "uploadPhoto": "Upload photo",
        "editPhoto": "Edit photo"
      },
      "save": " Save",
      "discard": " Discard",
      "back": " Back",
      "createAggregatedRegion": " New region",
      "pasteAggregatedRegion": " Paste region",
      "pendingSuggestions": "Suggestions",
      "rejectSuggestion": "Reject",
      "acceptSuggestion": "Accept",
      "cancelCopyBulletin": " Cancel",
      "createAvalancheProblem": " New problem",
      "ownRegions": "Own regions",
      "foreignRegions": "Foreign regions",
      "externalRegions": "External regions",
      "mapSelectRegion": "Select regions on the map.",
      "statusHeader": "Status of the bulletin",
      "suggestions": "Suggestions",
      "noBulletinsForSelectedDay": "No regions defined for this date.",
      "autosave": "Saved automatically",
      "regionEditable": "This region can be edited.",
      "regionNotEditable": "This region can not be edited.",
      "regionLocked": "This region is locked.",
      "changeDangerRatingElevation": "Extend the danger level",
      "mapTop": "Map above",
      "mapLeft": "Map aside",
      "showExternalRegions": "Show external regions",
      "hideExternalRegions": "Hide external regions",
      "showNotes": "Show notes",
      "hideNotes": "Hide notes",
      "incompleteAvalancheProblem": "Incomplete",
      "label": {
        "generalHeadlineComment": "General overall headline",
        "importantObservations": "Important observations",
        "avalancheProblems": "Avalanche problem",
        "aspects": "Aspects",
        "highlights": "Special alert",
        "avActivityHighlights": "Headline avalanche situation",
        "avActivityComment": "Description of avalanche danger",
        "travelAdvisoryHighlights": "Headline travel advisory",
        "travelAdvisoryComment": "Description of travel advisory",
        "snowpackStructureHighlights": "Headline snowpack structure",
        "snowpackStructureComment": "Description of snowpack structure",
        "dangerPatterns": "Danger patterns",
        "tendencyComment": "Description of tendency",
        "synopsisHighlights": "Headline weather synopsis",
        "synopsisComment": "Weather synopsis",
        "notes": "Notes",
        "noSnow": "No snow"
      },
      "copyRegion": {
        "label": "Copy warning region to another bulletin",
        "select": "Paste into ...",
        "currentBulletin": "This bulletin"
      },
      "title": {
        "avalancheProblem": "Avalanche problems",
        "dangerDescription": "Description of avalanche danger",
        "forenoon": "Forenoon",
        "afternoon": "Afternoon",
        "photos": "Photos",
        "snowpackStructure": "Snowpack structure",
        "tendency": "Tendency",
        "synopsis": "Weather",
        "showTranslations": " Show translations",
        "hideTranslations": " Hide translations"
      },
      "photos": {
        "url": "Image URL",
        "locationName": "Location",
        "microregion": "Microregion",
        "copyright": "Copyright",
        "date": "Date"
      },
      "placeholder": {
        "notes": "Write your notes here ..."
      },
      "pmDialog": {
        "noIFrameSupport": "Your browser does not support IFrames!"
      },
      "discardDialog": {
        "message": "Do you want to discard the changes?",
        "accept": "Yes",
        "reject": "No"
      },
      "deleteAggregatedRegionDialog": {
        "message": "Do you want to delete this region?",
        "accept": "Yes",
        "reject": "No"
      },
      "noRegionDialog": {
        "message": "At least one micro-region has to be yours.",
        "accept": "Ok"
      },
      "loadDialog": {
        "message": "Do you want to load the bulletins from the day before?<br><strong>This will delete all existing regions!</strong>",
        "accept": "Yes",
        "reject": "No"
      },
      "deleteAllWarningRegionsDialog": {
        "message": "Do you want to delete all warning regions?",
        "accept": "Yes",
        "reject": "No"
      },
      "loadSuggestionsFromDangerSourcesDialog": {
        "message": "Do you want to load suggestions from danger sources?<br><strong>This will delete all existing regions!</strong>",
        "accept": "Yes",
        "reject": "No"
      },
      "loadAutoSaveDialog": {
        "message": "Do you want to load the automatically saved bulletins?",
        "accept": "Yes",
        "reject": "No"
      },
      "saveErrorDialog": {
        "message": "There was an error saving the bulletins!",
        "accept": "Ok"
      },
      "changeErrorDialog": {
        "message": "There was an error changing the bulletins!",
        "accept": "Ok"
      },
      "loadingErrorDialog": {
        "message": "There was an error loading the bulletins!",
        "accept": "Ok"
      },
      "loadingJsonFileErrorDialog": {
        "message": "There was an error loading the bulletins from the JSON file!",
        "accept": "Ok"
      },
      "avalancheProblemErrorDialog": {
        "message": "Avalanche problem, aspects, snowpack stability, frequency and/or avalanche size is missing for at least one avalanche problem",
        "accept": "Ok"
      },
      "loadAvActivityCommentExampleTextDialog": {
        "message": "For which situation do you want to load an example text?",
        "newSnow": "New snow",
        "windSlab": "Wind slab",
        "persistentWeakLayers": "Persistent weak layers",
        "wetSnow": "Wet snow",
        "glidingSnow": "Gliding snow",
        "favourableSituation": "Favourable situation",
        "cancel": "Cancel"
      },
      "removeDaytimeDependencyDialog": {
        "message": "Which avalanche problems do you want to keep?",
        "cancel": "Cancel"
      },
      "strategicMindsetDialog": {
        "title": "Strategic Mindsets",
        "introduction": "The \"Strategic Mindsets\" are intended to express our mental attitude with regard to the avalanche situation and its development in the corresponding warning region. It should not be derived directly from the hazard assessment, but rather understood and used as an intuitive impression of the overall situation. The \"Strategic Mindsets\" are therefore primarily a communication tool. Using the mindsets and associated definitions, we forecasters can quickly and efficiently exchange information about the development of the hazard situation and find a common language for communication.",
        "description": {
          "title": "Description:",
          "text": {
            "assessment": "There is <b>great uncertainty</b> in the hazard assessment due to <b>insufficient information</b> from the field.",
            "stepping_out": "<b>Decreasing tendency</b> of the hazard situation (also within a danger level).",
            "status_quo": "Same hazardous situation. <b>No significant change</b> compared to the previous day.",
            "stepping_back": "<b>Increasing tendency</b> of the hazard situation (also within a danger level).",
            "entrenchment": "<b>Almost constant, tense hazardous situation.</b> The main danger comes from (a) <b>persistent weak layer</b>(s) susceptible to interference.",
            "free_ride": "<b>Low avalanche danger</b> with generally stable snow cover. Only small avalanches are possible in extremely steep terrain. ",
            "high_alert": "Exceptional situation with <b>high or very high avalanche danger</b>. Spontaneous avalanches of <b>very large or extreme magnitude</b> are possible",
            "spring_diurnal": "Wet snow avalanches during the course of the day, which are subject to a <b>clear diurnal cycle</b>, are decisive for the risk assessment."
          }
        },
        "communication": {
          "title": "Communication:",
          "text": {
            "assessment": "Avalanche situation must be checked locally. Restraint is recommended.",
            "stepping_out": "Gradual decrease in danger. However, caution is still required and the improving situation should be assessed locally before entering riskier terrain.  ",
            "status_quo": "Hazardous situation is unchanged. Feedback from observers helps to better outline the hazardous situation. More favourable terrain should be communicated with emphasis. ",
            "stepping_back": "Clear communication of the increase in avalanche danger - even within a danger level. Information on the causes supports comprehensibility in communication. ",
            "entrenchment": "Caution and restraint are required. Situation hardly changes. If possible, provide as precise information as possible on distribution and possibility to trigger. Increased communication of observations that reveal the situation and trigger restraint.",
            "free_ride": "Little text. Emphasise the generally favourable overall situation and potentially isolated hazard areas",
            "high_alert": "Communication across all channels. The focus is no longer on winter sports. Danger even in areas that are not usually at risk of avalanches.",
            "spring_diurnal": "Favourable situation in the morning, increasing during the day. Assessment should be made locally by observing the softening of the melt-freeze crust and the increasing soaking of the snow cover."
          }
        },
        "examples": {
          "title": "Examples:",
          "text": {
            "assessment": "Start of the season.",
            "stepping_out": "Cooling leads to a decrease in the risk of wet snow avalanches after a warm and humid weather phase.",
            "status_quo": "Consistent wind-slab problem with cold temperatures, loose snow and wind.",
            "stepping_back": "Abundant fresh snowfall leads to an increase in the danger situation.",
            "entrenchment": "Critical persistent weak layers problem with potential for dangerously large avalanches. The situation is only stabilising very slowly and requires a great deal of restraint.",
            "free_ride": "Low avalanche danger, no persistent weak layers, all terrain has already been groomed.",
            "high_alert": "Danger level 4 or higher due to large amounts of fresh snow and/or problematic, persistent weak layers. ",
            "spring_diurnal": "Spring situation with dry high-pressure weather and moderate temperatures with otherwise mostly stable old snow cover."
          }
        },
        "strategicMindset": {
          "assessment": "High Uncertainty",
          "stepping_out": "Improving",
          "status_quo": "Status Quo",
          "stepping_back": "Deteriorating",
          "entrenchment": "Persistent Unstable",
          "free_ride": "Favorable",
          "high_alert": "High Alert",
          "spring_diurnal": "Spring Diurnal"
        }
      },
      "decisionTree": {
        "filepath": "./assets/img/decision_tree-en.svg",
        "decisionTree": "Decision tree",
        "save": "Save",
        "discard": "Discard"
      }
    },
    "table": {
      "title": {
        "date": "Date"
      },
      "status": {
        "missing": "missing",
        "draft": "draft",
        "submitted": "submitted",
        "published": "published",
        "updated": "updated",
        "resubmitted": "resubmitted",
        "republished": "republished"
      },
      "publishBulletinsDialog": {
        "message": "Do you want to publish the bulletin?"
      },
      "publicationStatusDialog": {
        "headline": "Publication Status",
        "publishedBy": "Published by: ",
        "publishedAt": "Published at: ",
        "validFor": "Valid for: ",
        "title": {
          "prod": "Serious stuff",
          "test": "Test system",
          "task": "Task",
          "language": {
            "all": "ALL",
            "de": "DE",
            "it": "IT",
            "en": "EN"
          }
        },
        "email": {
          "label": "Emails",
          "tooltip": "Send Emails",
          "success": "Emails successfully sent!",
          "error": "Emails could not be sent!"
        },
        "telegram": {
          "label": "Telegram Messages",
          "tooltip": "Send Telegram Messages",
          "success": "Telegram Messages successfully sent!",
          "error": "Telegram Messages could not be sent!"
        },
        "whatsapp": {
          "label": "WhatsApp Messages",
          "tooltip": "Send WhatsApp Messages",
          "success": "WhatsApp Messages successfully sent!",
          "error": "WhatsApp Messages could not be sent!"
        },
        "push": {
          "label": "Push Notifications",
          "tooltip": "Send Push Notifications",
          "success": "Push Notifications successfully sent!",
          "error": "Push Notifications could not be sent!"
        },
        "accept": "Ok",
        "confirm": "Do you want to send {{channel}} ({{language}})?"
      },
      "mediaFileDialog": {
        "headline": "Media File",
        "important": "IMPORTANT",
        "missingFile": "No file selected!",
        "uploadError": "Upload failed!",
        "accept": "Send",
        "reject": "Cancel"
      },
      "publishBulletinsErrorDialog": {
        "message": "There was an error publishing the bulletins!",
        "accept": "Ok"
      },
      "submitBulletinsDialog": {
        "message": "Do you want to submit the bulletin?"
      },
      "submitBulletinsErrorDialog": {
        "message": "There was an error submitting the bulletins!",
        "accept": "Ok"
      },
      "submitBulletinsDuplicateRegionDialog": {
        "message": "Regions rated multiple times! Bulletin can not be submitted.",
        "accept": "Ok"
      },
      "checkBulletinsErrorDialog": {
        "message": "There was an error checking the bulletins!",
        "accept": "Ok"
      },
      "previewErrorDialog": {
        "message": "Preview could not be loaded!",
        "accept": "Ok"
      },
      "checkBulletinsDialog": {
        "message": "Check bulletin",
        "ok": "(everything alright)"
      },
      "publishAllDialog": {
        "message": "Do you want to publish all regions?",
        "changeMessage": "Do you want to publish all regions? (no messages)"
      },
      "bulletinCheck": {
        "missingDangerRating": "Danger rating not set",
        "missingDangerRatingModificator": "Danger rating modificator not set",
        "missingRegion": "Regions not rated",
        "duplicateRegion": "Regions rated multiple times",
        "missingAvActivityHighlights": "Headline avalanche situation missing",
        "missingAvActivityComment": "Description of avalanche danger missing",
        "missingSnowpackStructureHighlights": "Headline snowpack structure missing",
        "missingSnowpackStructureComment": "Description of snowpack structure missing",
        "pendingSuggestions": "Pending suggestions",
        "incompleteTranslation": "Incomplete translation"
      }
    }
  },
  "training": {
    "training": "Training",
    "timestamp": "Training timestamp"
  },
  "admin": {
    "loadingStatistics": "Creating CSV ...",
    "server-configuration": {
      "title": "Server",
      "button": {
        "create": "Create server",
        "save": "Save"
      },
      "table": {
        "name": "Name",
        "userName": "Username",
        "password": "Password",
        "publishAt5PM": "Publish at 5PM",
        "publishAt8AM": "Publish at 8AM",
        "pdfDirectory": "Directory for PDF",
        "htmlDirectory": "Directory for HTML",
        "serverImagesUrl": "Path to server images",
        "dangerLevelElevationDependency": "Elevation dependency of danger level",
        "mapsPath": "Path to maps",
        "mediaPath": "Path to media files",
        "mapProductionUrl": "URL for map production",
        "apiUrl": "API URL"
      },
      "success": "Configuration successfully saved",
      "error": "Configuration could not be saved"
    },
    "region-configuration": {
      "title": "Region",
      "button": {
        "create": "Create region",
        "save": "Save"
      },
      "table": {
        "general": {
          "title": "General"
        },
        "publication": {
          "title": "Publication"
        },
        "components": {
          "title": "Components"
        },
        "configuration": {
          "title": "Configuration"
        },
        "languageConfiguration": {
          "title": "Language configuration"
        }
      },
      "success": "Configuration successfully saved",
      "error": "Configuration could not be saved"
    },
    "users": {
      "title": "Users",
      "button": {
        "create": " Create user"
      },
      "tooltip": {
        "edit": "Edit user",
        "changePassword": "Change password",
        "delete": "Delete user"
      },
      "table": {
        "name": "Name",
        "email": "Email",
        "organization": "Organization",
        "regions": "Regions",
        "roles": "Roles"
      },
      "deleteUserModalDialog": {
        "message": "Do you want to delete the user?",
        "accept": "Yes",
        "reject": "No"
      },
      "deleteUser": {
        "success": "User deleted",
        "error": "User could not be deleted"
      },
      "createUser": {
        "success": "User created",
        "error": "User could not be created"
      },
      "updateUser": {
        "success": "User saved",
        "error": "User could not be saved"
      }
    },
    "createUser": {
      "table": {
        "image": "Image",
        "name": "Name",
        "email": "Email",
        "organization": "Organization",
        "password": "Password",
        "password2": "Repeat password",
        "roles": "Roles",
        "regions": "Regions"
      },
      "error": {
        "name": {
          "required": "Please enter a name"
        },
        "email": {
          "required": "Please enter an email address",
          "invalid": "Email address is invalid"
        },
        "password": {
          "required": "Please enter a password",
          "length": "Password has to be at least 8 characters",
          "mismatch": "Passwords do not match"
        }
      },
      "button": {
        "create": "Create user",
        "update": "Update user",
        "cancel": "Cancel"
      }
    },
    "observations": {
      "table": "Table",
      "map": "Map",
      "gallery": "Gallery",
      "filters": "Filters",
      "details": "Details",
      "title": "Observations",
      "newObservation": "New observation",
      "exportObservations": "Export observations (GeoJSON)",
      "exportStatistics": "Export statistics (CSV)",
      "toggleFilterBar": "Show/hide filter bar",
      "button": {
        "submit": "Download"
      },
      "label": {
        "dateRange": "Period",
        "observer": "Observer"
      },
      "selectRegion": {
        "placeholder": "Region",
        "selectionLabel": "{0} region(s) selected"
      },
      "selectSources": {
        "placeholder": "Sources",
        "selectionLabel": "{0} source(s) selected"
      },
      "charts": {
        "charts": "Charts",
        "nan": "Without specification",
        "reload": "Reload",
        "classify": "Classify",
        "label": "Label",
        "invert": "Invert",
        "reset": "Reset",
        "aspect": {
          "caption": "Aspect"
        },
        "elevation": {
          "caption": "Elevation"
        },
        "stability": {
          "caption": "Stability"
        },
        "observationType": {
          "caption": "Observation Type"
        },
        "importantObservation": {
          "caption": "Important"
        },
        "avalancheProblem": {
          "caption": "Avalanche Problem"
        },
        "dangerPattern": {
          "caption": "Danger Pattern"
        },
        "dangerSource": {
          "caption": "Danger Source"
        },
        "days": {
          "caption": "Day"
        }
      }
    },
    "blog": {
      "title": "Blog",
      "language": {
        "title": "Language",
        "de": "DE",
        "it": "IT",
        "en": "EN"
      },
      "all": {
        "tooltip": "Send Emails, Telegram, WhatsApp and Push",
        "success": "Email, Telegram, Whatsapp and Push successfully sent!",
        "error": "Email, Telegram, WhatsApp and Push could not be sent!"
      },
      "email": {
        "tooltip": "Send Emails",
        "success": "Email successfully sent!",
        "error": "Email could not be sent!"
      },
      "telegram": {
        "tooltip": "Send via Telegram Channel",
        "success": "Telegram successfully sent!",
        "error": "Telegram could not be sent!"
      },
      "whatsapp": {
        "tooltip": "Send via WhatsApp Channel",
        "success": "WhatsApp successfully sent!",
        "error": "WhatsApp could not be sent!"
      },
      "push": {
        "tooltip": "Send via Push Notifications",
        "success": "Push successfully sent!",
        "error": "Push could not be sent!"
      }
    }
  },
  "settings": {
    "title": "Settings",
    "effectiveRole": "Effective role",
    "effectiveRoleDefault": "All roles",
    "changePassword": {
      "title": "Change password",
      "oldPassword": {
        "label": "Current password",
        "placeholder": "Current password"
      },
      "newPassword1": {
        "label": "New password",
        "placeholder": "New password"
      },
      "newPassword2": {
        "label": "New password (repeat)",
        "placeholder": "New password"
      },
      "submit": "Change password",
      "passwordChanged": "Password successfully changed",
      "passwordChangeError": "Password could not be changed",
      "passwordIncorrect": "Current password incorrect",
      "error": {
        "oldPassword": {
          "required": "Please enter your current password"
        },
        "newPassword": {
          "required": "Please enter a new password",
          "mismatch": "Passwords do not match"
        }
      }
    },
    "display": {
      "title": "Display",
      "table": {
        "showCaaml": "Show CAAML",
        "showJson": "Show JSON"
      }
    },
    "passkeys": {
      "title": "Passkeys",
      "unsupported": "Your browser does not support passkeys.",
      "empty": "No passkeys registered yet.",
      "unnamed": "Passkey",
      "lastUsed": "Last used",
      "neverUsed": "Never used",
      "namePlaceholder": "e.g. iPhone, YubiKey",
      "add": "Add passkey",
      "delete": "Delete",
      "added": "Passkey added",
      "addError": "Could not add passkey",
      "deleteError": "Could not delete passkey"
    }
  },
  "statistics": {
    "title": "Statistics",
    "bulletins": "Avalanche Bulletins",
    "dangerSources": "Danger Sources",
    "button": {
      "submit": "Download"
    },
    "label": {
      "dateRange": "Period",
      "extended": "Extended",
      "duplicates": "Duplicates"
    },
    "error": {
      "downloadFailed": "The statistics export could not be downloaded. Please try again."
    }
  },
  "strategicMindset": {
    "title": "Strategic Mindset",
    "assessment": "High Uncertainty",
    "stepping_out": "Improving",
    "status_quo": "Status Quo",
    "stepping_back": "Deteriorating",
    "entrenchment": "Persistent Unstable",
    "free_ride": "Favorable",
    "high_alert": "High Alert",
    "spring_diurnal": "Spring Diurnal"
  },
  "observationType": {
    "DrySnowfallLevel": "Dry snowfall level",
    "TimeSeries": "Time series",
    "Incident": "Incident",
    "Profile": "Snow profile",
    "Closure": "Closure",
    "Blasting": "Blasting",
    "Avalanche": "Avalanche",
    "Evaluation": "Evaluation",
    "SimpleObservation": "Simple observation",
    "Webcam": "Webcam"
  },
  "importantObservation": {
    "ForBlog": "For blog",
    "SurfaceHoar": "Surface hoar",
    "Graupel": "Graupel",
    "StabilityTest": "Stability test",
    "IceFormation": "Ice formation",
    "VeryLightNewSnow": "Very light new snow"
  },
  "elevationTolerance": {
    "exact": "exact",
    "50m": "±50m",
    "100m": "±100m",
    "200": "±200m"
  },
  "elevationPeriod": {
    "duringPrecipitationEvent": "Dry snowfall boundary for the entire precipitation event",
    "observationPeriod": "Dry snowfall boundary at the time of observation"
  },
  "aspect": {
    "N": "N",
    "NE": "NE",
    "E": "E",
    "SE": "SE",
    "S": "S",
    "SW": "SW",
    "W": "W",
    "NW": "NW"
  },
  "role": {
    "SUPERADMIN": "Super Administrator",
    "ADMIN": "Administrator",
    "FORECASTER": "Forecaster",
    "FOREMAN": "Foreman",
    "OBSERVER": "Observer"
  },
  "tendency": {
    "decreasing": " Avalanche danger decreases",
    "steady": " Avalanche danger stays the same",
    "increasing": " Avalanche danger increases"
  },
  "complexity": {
    "easy": " Easy",
    "challenging": " Challenging",
    "complex": " Complex"
  },
  "glidingSnowActivity": {
    "low": "low",
    "medium": "medium",
    "high": "high"
  },
  "wetness": {
    "dry": "dry",
    "moist": "moist",
    "wet": "wet"
  },
  "characteristic": {
    "low": "low",
    "medium": "medium",
    "high": "high",
    "very_high": "very high"
  },
  "thickness": {
    "thin": "thin",
    "thick": "thick"
  },
  "snowpackPosition": {
    "upper": "upper",
    "middle": "middle",
    "lower": "lower",
    "ground": "ground"
  },
  "weakLayerCrust": {
    "no": "no",
    "partly": "partly",
    "yes": "yes"
  },
  "creationProcess": {
    "radiation_recrystallization": "radiation",
    "diurnal_recrystallization": "diurnal",
    "melt_layer_recrystallization": "melt layer",
    "surface_hoar_formation": "surface hoar"
  },
  "recognizability": {
    "very_easy": "very easy",
    "easy": "easy",
    "hard": "hard",
    "very_hard": "very hard"
  },
  "distribution": {
    "isolated": "isolated",
    "specific": "specific",
    "widespread": "widespread"
  },
  "probability": {
    "likely": "likely",
    "possible": "possible",
    "unlikely": "unlikely"
  },
  "detailedDaytime": {
    "evening": "evening",
    "first_night_half": "first night half",
    "second_night_half": "second night half",
    "morning": "morning",
    "forenoon": "forenoon",
    "afternoon": "afternoon"
  },
  "slopeGradient": {
    "moderately_steep": "moderately steep",
    "steep": "steep",
    "very_steep": "very steep",
    "extremely_steep": "extremely steep"
  },
  "handHardness": {
    "fist": "F",
    "four_fingers": "4F",
    "one_finger": "1F",
    "pencil": "P",
    "knife": "K",
    "ice": "I"
  },
  "hardnessTendency": {
    "decreasing": "softer below",
    "steady": "uniform",
    "increasing": "softer above"
  },
  "terrainType": {
    "gullies_and_bowls": "gullies and bowls",
    "adjacent_to_ridgelines": "adjacent to ridgelines",
    "distant_from_ridgelines": "distant from ridgelines",
    "in_the_vicinity_of_peaks": "in the vicinity of peaks",
    "pass_areas": "pass areas",
    "shady_slopes": "shady slopes",
    "sunny_slopes": "sunny slopes",
    "grassy_slopes": "grassy slopes",
    "cut_slopes": "cut slopes",
    "wind_loaded_slopes": "wind loaded slopes",
    "base_of_rock_walls": "base of rock walls",
    "behind_abrupt_changes_in_the_terrain": "behind abrupt changes in the terrain",
    "transitions_into_gullies_and_bowls": "transitions into gullies and bowls",
    "areas_where_the_snow_cover_is_rather_shallow": "areas where the snow cover is rather shallow",
    "transitions_from_a_shallow_to_a_deep_snowpack": "transitions from a shallow to a deep snowpack",
    "highly_frequented_off_piste_terrain": "highly frequented off piste terrain",
    "little_used_backcountry_terrain": "little used backcountry terrain",
    "places_that_are_protected_from_the_wind": "places that are protected from the wind",
    "regions_exposed_to_the_foehn_wind": "regions exposed to the foehn wind",
    "regions_with_a_lot_of_snow": "regions with a lot of snow",
    "regions_exposed_to_precipitation": "regions exposed to precipitation",
    "regions_exposed_to_heavier_precipitation": "regions exposed to heavier precipitation"
  },
  "dangerSign": {
    "shooting_cracks": "shooting cracks",
    "whumpfing": "whumpfing",
    "fresh_avalanches": "fresh avalanches",
    "glide_cracks": "glide cracks"
  },
  "changeRegionDialog": {
    "message": "Do you want to change the region?",
    "accept": "Yes",
    "reject": "No"
  },
  "zamg": {
    "table": "Table",
    "map": "Map",
    "region": "Region",
    "newSnow": "New snow"
  },
  "snowpack": {
    "plotType": {
      "LWC_stratigraphy": "wet snow: liquid water content",
      "wet_snow_instability": "wet snow: wet snow instability",
      "Sk38_stratigraphy": "persistent weak layers: SK38 stability index",
      "stratigraphy": "persistent weak layers: snow stratigraphy"
    },
    "aspect": {
      "flat": "flat",
      "north": "north",
      "south": "south"
    },
    "meteo": {
      "new_snow_plot_3day": "new snow (3d)",
      "new_snow_plot_7day": "new snow (7d)",
      "new_snow_plot_1month": "new snow (31d)",
      "new_snow_plot_season": "new snow (season)",
      "new_snow_plot_forecast": "new snow (forecast)",
      "wet_snow_plot_3day": "wet snow (3d)",
      "wet_snow_plot_7day": "wet snow (7d)",
      "wet_snow_plot_1month": "wet snow (31d)",
      "wet_snow_plot_season": "wet snow (season)",
      "wet_snow_plot_forecast": "wet snow (forecast)",
      "HS_table_24h": "snow height table (1d)",
      "HS_table_72h": "snow height table (3d)",
      "HS_table_season": "snow height table (season)",
      "HS_table_forecast": "snow height table (forecast)",
      "TA_table_24h": "temperature table (1d)",
      "TA_table_72h": "temperature table (3h)",
      "TA_table_season": "temperature table (season)"
    }
  },
  "grainShape": {
    "PP": {
      "code": "PP",
      "class": "Precipitation Particles"
    },
    "PPgp": {
      "code": "PPgp",
      "class": "Graupel"
    },
    "DF": {
      "code": "DF",
      "class": "Decomposing and Fragmented precipitation particles"
    },
    "RG": {
      "code": "RG",
      "class": "Rounded Grains"
    },
    "FC": {
      "code": "FC",
      "class": "Faceted Crystals"
    },
    "FCxr": {
      "code": "FCxr",
      "class": "Rounding Faceted Crystals"
    },
    "DH": {
      "code": "DH",
      "class": "Depth Hoar"
    },
    "SH": {
      "code": "SH",
      "class": "Surface Hoar"
    },
    "MF": {
      "code": "MF",
      "class": "Melt Forms"
    },
    "MM": {
      "code": "MM",
      "class": "Machine Made"
    },
    "MFcr": {
      "code": "MFcr",
      "class": "Melt-freeze crust"
    },
    "IF": {
      "code": "IF",
      "class": "Ice Formations"
    }
  },
  "button": {
    "true": "Yes",
    "false": "No",
    "ok": "Ok",
    "yes": "Yes",
    "no": "No"
  },
  "observations": {
    "$externalURL": "External URL (e.g. to photo database)",
    "$type": "Observation type",
    "allowEdit": "Edit external observation",
    "allowEditTooltip": "This will prevent overwrites from {{ value }}",
    "editIconTooltip": "Edited observation - receives no updates from {{ value }}",
    "aspect": "Aspect",
    "authorName": "Author name",
    "avalancheLength": "Avalanche length",
    "avalancheProblem": "Avalanche problem",
    "avalancheProblems": "Avalanche problem",
    "avalancheSize": "Avalanche size",
    "avalancheType": "Avalanche type",
    "avalancheWidth": "Avalanche width",
    "search": "Search",
    "count": "# observations:",
    "elevationTolerance": "Accuracy of elevation data",
    "elevationPeriod": "Elevation time period",
    "layers": {
      "observers": "Observers",
      "weatherStations": "Weather stations",
      "webcams": "Webcams",
      "observations": "Observations"
    },
    "weatherStations": {
      "tooltips": {
        "drySnowfallLevel": "Dry snowfall level",
        "globalRadiation": "Global radiation",
        "newSnow": "New snow",
        "snowLine": "Snow line",
        "snowHeight": "Snow height",
        "snowDifference": "Snow difference",
        "airTemperature": "Air temperature",
        "airTemperatureMax": "Air temperature Max",
        "airTemperatureMin": "Air temperature Min",
        "surfaceTemperature": "Surface temperature",
        "surfaceHoar": "Potential surface hoar formation",
        "surfaceHoarCalc": "Potential surface hoar formation (Lehning et. al.)",
        "dewPoint": "Dew point temperature",
        "relativeHumidity": "Relative humidity",
        "windDirection": "Wind direction",
        "windSpeed": "Wind speed",
        "windGust": "Wind gust"
      }
    },
    "webcams": {
      "tooltips": {
        "minusTenMinutes": "10min back",
        "minusOneHour": "1h back",
        "plusTenMinutes": "10min forward",
        "plusOneHour": "1h forward"
      }
    },
    "button": {
      "add": "Add observation",
      "save": "Save observation",
      "delete": "Delete observation",
      "deleteConfirm": "Delete observation?",
      "discard": "Discard",
      "copyDate": "Copy event date"
    },
    "comment": "Comment",
    "content": "Content",
    "dangerPatterns": "Danger patterns",
    "dangerRating": "Danger rating",
    "dangerSource": "Danger source",
    "elevation": "Elevation",
    "elevationRange": "Elevation range",
    "elevationLowerBound": "Elevation lower bound",
    "elevationUpperBound": "Elevation upper bound",
    "eventDate": "Event date",
    "eventType": "Event type",
    "eventTypes": {
      "IMPORTANT": "Important event",
      "NEIGHBOR_REGION": "Neighbouring region",
      "NORMAL": "Normal event",
      "PERSON_DEAD": "Event involving persons (dead)",
      "PERSON_INJURED": "Event involving persons (injured)",
      "PERSON_NO": "Event not involving persons",
      "PERSON_UNINJURED": "Event involving persons (uninjured)",
      "PERSON_UNKNOWN": "Event (unknown)",
      "TRAFFIC": "Traffic"
    },
    "externalURL": "External URL (e.g. to photo database)",
    "fractureDepth": "Fracture depth",
    "hasCoordinates": "Has coordinates",
    "incline": "Incline",
    "importantObservations": "Important observations",
    "latitude": "Latitude",
    "locationName": "Location",
    "longitude": "Longitude",
    "observationType": "Observation type",
    "personInvolvement": "Person involvement",
    "reportDate": "Report date",
    "showTable": "Table",
    "stability": "Snowpack Stability",
    "withoutCoordinates": "Observations without coordinates:",
    "sidebar": {
      "filter": {
        "title": "Filter"
      },
      "legend": {
        "title": "Legend"
      },
      "sources": {
        "title": "Data Sources"
      },
      "views": {
        "title": "Views"
      }
    }
  },
  "personInvolvement": {
    "Dead": "Event involving persons (dead)",
    "Injured": "Event involving persons (injured)",
    "Yes": "Event involving persons",
    "No": "Event not involving persons",
    "Uninjured": "Event involving persons (uninjured)",
    "Unknown": "Event (unknown)"
  },
  "units": {
    "cm": "cm",
    "mm": "mm",
    "m": "m"
  },
  "qfa": {
    "day": "Day",
    "time": "Time",
    "back": " Back",
    "parameters": {
      "DUST": "sahara dust",
      "N": "total cloud cover in /8",
      "Nh": "high cloud cover in /8",
      "Nm": "medium high cloud cover in /8",
      "Nl": "low cloud cover in /8",
      "N-CU": "cumulus cloud cover in /8",
      "AUSL.T": "trigger temperature",
      "SHW-IX": "Showalter-Index",
      "WX -CUF": "significant weather: NIL (none), RASH (rain), TS (thunder storm)",
      "RR": "total precipitation [mm]",
      "RR-str": "stratiform precipitation",
      "CONV": "convective precipitation [mm]",
      "SN": "precipitation in form of snow [mm]",
      "SN--RA": "snowline [m]",
      "QAO ": "{{value}} hPa eq. mean wind, direction and strength, [°] and [m/s]",
      "QAN": "mean wind on the ground, direction and strength, [°] and [m/s]",
      "QANmax": "max. wind (gusts) on the ground [m/s]",
      "T ": "{{value}} hPa eq. temperature [°C]",
      "T m": "temperature on {{value}}m [°C]",
      "T 2m": "temperature on 2m [°C]",
      "Tk 2m": "temperature on 2m [°K]",
      "T GND": "ground temperature",
      "Max-ADI": "maximum mixing temperature [°C]",
      "Min Max": "min./max. temperature in the last 24h",
      "FROST": "zero degree line [m]",
      "W cm": "500 hPa eq. vertical wind [cm/s]",
      "W --": "700 hPa eq. vertical wind [cm/s]",
      "W s": "{{value}} hPa eq. vertical wind [cm/s]",
      "H ": "{{value}} hPa geopotential height [m]",
      "RF ": "{{value}} hPa eq. relative moisture [%]"
    }
  },
  "awsome": {
    "(nearly) none": "(nearly) none",
    "{{active}} active, {{visible}} visible in the chart": "{{active}} active, {{visible}} visible in the chart",
    "{{band}}: series {{series}}, panel {{panel}}": "{{band}}: series {{series}}, panel {{panel}}",
    "{{count}} read": "{{count}} read",
    "{{elevation}} m": "{{elevation}} m",
    "{{index}} has no 2 to 4 chained classes the matrix can read": "{{index}} has no 2 to 4 chained classes the matrix can read",
    "{{label}} selected: the shares are conditioned": "{{label}} selected: the shares are conditioned",
    "{{lower}}–{{upper}} m": "{{lower}}–{{upper}} m",
    "{{share}} % {{stability}} of {{total}} slopes ({{margin}})": "{{share}} % {{stability}} of {{total}} slopes ({{margin}})",
    "{{share}} % good of {{total}} slopes; every other class {{none}}": "{{share}} % good of {{total}} slopes; every other class {{none}}",
    "{{stability}} in {{frequency}} locations, size {{size}}: {{levels}}": "{{stability}} in {{frequency}} locations, size {{size}}: {{levels}}",
    "→ {{next}}": "→ {{next}}",
    "< {{elevation}} m": "< {{elevation}} m",
    "≥ {{elevation}} m": "≥ {{elevation}} m",
    "above {{elevation}} m": "above {{elevation}} m",
    "Active datetags": "Active datetags",
    "Aggregation band": "Aggregation band",
    "All": "All",
    "all aspects": "all aspects",
    "all elevations": "all elevations",
    "also {{level}}": "also {{level}}",
    "aspects {{aspects}}": "aspects {{aspects}}",
    "at any elevation": "at any elevation",
    "below {{elevation}} m": "below {{elevation}} m",
    "between {{lower}} and {{upper}} m": "between {{lower}} and {{upper}} m",
    "Clear the {{label}} selection": "Clear the {{label}} selection",
    "Danger level": "Danger level",
    "danger level series": "danger level series",
    "Date": "Date",
    "Datetag": "Datetag",
    "Depth": "Depth",
    "Dry instability": "Dry instability",
    "Each read slope's stability class comes from the classifying stability index.": "Each read slope's stability class comes from the classifying stability index.",
    "Elevation cut": "Elevation cut",
    "fair (<0.78)": "fair (<0.78)",
    "fair (<1.05)": "fair (<1.05)",
    "few above {{few}} %, some from {{some}} %": "few above {{few}} %, some from {{some}} %",
    "flat": "flat",
    "good": "good (map: rather stable)",
    "good throughout": "good throughout",
    "Grain type": "Grain type",
    "How the danger level is derived": "How the danger level is derived",
    "loading": "loading",
    "Lower elevation cut": "Lower elevation cut",
    "LWC index": "LWC index",
    "many above {{many}} %": "many above {{many}} %",
    "median of the decisive class's size estimates": "median of the decisive class's size estimates",
    "New snow": "New snow",
    "no aspect": "no aspect",
    "no danger level series": "no danger level series",
    "no elevation": "no elevation",
    "no index value": "no index value",
    "no size": "no size",
    "no snow or no model output": "no snow or no model output",
    "No split": "No split",
    "no stability index to read": "no stability index to read",
    "None": "None",
    "none or nearly none": "none or nearly none",
    "not read": "not read",
    "nothing read": "nothing read",
    "nothing read {{band}}: {{count}} selected": "nothing read {{band}}: {{count}} selected",
    "nothing selected {{band}}": "nothing selected {{band}}",
    "p{{percentile}} of the decisive class's size estimates": "p{{percentile}} of the decisive class's size estimates",
    "p{{percentile}} size {{size}}": "p{{percentile}} size {{size}}",
    "poor (<=3)": "poor (<=3)",
    "poor (<0.95)": "poor (<0.95)",
    "poor (>=0.78)": "poor (>=0.78)",
    "Punstable": "Punstable",
    "rather stable (<0.7)": "rather stable (<0.7)",
    "rather stable (<1)": "rather stable (<1)",
    "rather stable (>1.05)": "rather stable (>1.05)",
    "read": "read",
    "Region": "Region",
    "Reload": "Reload",
    "Save and reload": "Save and reload",
    "Saving failed": "Saving failed",
    "Select the elevations above {{elevation}} m": "Select the elevations above {{elevation}} m",
    "Select the elevations below {{elevation}} m": "Select the elevations below {{elevation}} m",
    "Select the elevations between {{lower}} and {{upper}} m": "Select the elevations between {{lower}} and {{upper}} m",
    "selection not loaded": "selection not loaded",
    "series ≠ panel at this step": "series ≠ panel at this step",
    "series ignores: {{types}}": "series ignores: {{types}}",
    "size {{size}}": "size {{size}}",
    "Size estimate": "Size estimate",
    "SK38 (RTA > 0.8)": "SK38 (RTA > 0.8)",
    "some from {{some}} %, many above {{many}} %": "some from {{some}} %, many above {{many}} %",
    "the API pools the timeseries over every {{label}}, it cannot ask for the locations without one": "the API pools the timeseries over every {{label}}, it cannot ask for the locations without one",
    "the API reads the danger level series without the {{types}} selection": "the API reads the danger level series without the {{types}} selection",
    "The avalanche size is the {{statistic}}.": "The avalanche size is the {{statistic}}.",
    "the decisive class carries no size": "the decisive class carries no size",
    "The decisive class is the most unstable class whose share of the band's read slopes is above the {{few}} bound; without one the band is good throughout and reads 1. Its frequency class, {{none}}, {{few}}, {{some}} or {{many}}, follows the configured bounds.": "The decisive class is the most unstable class whose share of the band's read slopes is above the {{few}} bound; without one the band is good throughout and reads 1. Its frequency class, {{none}}, {{few}}, {{some}} or {{many}}, follows the configured bounds.",
    "the panel applies the {{types}} selection, the series does not": "the panel applies the {{types}} selection, the series does not",
    "the series reads the API's population, every stored slope with a compass aspect, the panel the loaded features": "the series reads the API's population, every stored slope with a compass aspect, the panel the loaded features",
    "timeseries ignores: {{label}}": "timeseries ignores: {{label}}",
    "Upper elevation cut": "Upper elevation cut",
    "very poor (<=0.5)": "very poor (<=0.5)",
    "very poor (>=0.85)": "very poor (>=0.85)",
    "very poor (>3)": "very poor (>3)",
    "Wet instability": "Wet instability"
  },
  "channelStatus": {
    "loading": "Loading channel status information...",
    "triggerStatusChecks": "Trigger status checks"
  },
  "lineaexport": {
    "searchfieldplaceholder": "Search stations...",
    "hint": "Press Enter to add"
  },
  "awsstats": {
    "title": "AWS statistics",
    "label": {
      "loading": "Loading data...",
      "startDate": "Start date",
      "endDate": "End date",
      "selectWeatherStation": "Select weather station",
      "selectMicroRegions": "Select micro-regions",
      "clearselection": "Clear selection",
      "noMicroRegionsSelected": "none",
      "last7days": "Last 7 days",
      "last30days": "Last 30 days",
      "last90days": "Last 90 days",
      "loadData": "Load data",
      "charttypes": "Chart types"
    },
    "charts": {
      "aws-observations": "AWS observations",
      "aws-danger-rating": "Danger rating",
      "aws-danger-rating-altitude": "Danger rating by altitude",
      "aws-avalanche-activity-index": "Avalanche activity index",
      "aws-danger-rating-danger-source-variants": "Danger source variants",
      "aws-danger-source-variants-matrix-parameter-stability": "Danger source variants stability",
      "aws-danger-source-variants-matrix-parameter-frequency": "Danger source variants frequency",
      "aws-danger-source-variants-matrix-parameter-avalanche-size": "Danger source variants avalanche size"
    },
    "error": {
      "startDateBeforeEndDate": "Start date must be before or equal to end date.",
      "failedLoadData": "Failed to load data for selected date range.",
      "startDateEndDateRequired": "Start date and end date are required."
    }
  },
  "yearlystats": {
    "title": "Yearly Statistics",
    "label": {
      "startDate": "Start date",
      "endDate": "End date",
      "loaddata": "Load data",
      "last90Days": "Last 90 days",
      "last180Days": "Last 180 days",
      "currentSeason": "Current season",
      "regionCode": "Region code",
      "allRegions": "ALL",
      "virtualTrainings": "Virtual trainings (dates)",
      "fieldTrainings": "Field trainings (dates)",
      "dangerRatingReference": "Danger rating reference"
    },
    "charts": {
      "aws-danger-rating-micro-regions-bars": "AWS Danger Rating - Micro Regions - Bars",
      "aws-danger-rating-micro-regions": "AWS Danger Rating - Micro Regions",
      "aws-danger-rating-distribution": "AWS Danger Rating - Distribution",
      "aws-danger-pattern-micro-regions": "AWS Danger Pattern - Micro Regions",
      "aws-avalanche-problem-micro-regions": "AWS Avalanche Problem - Micro Regions",
      "aws-products": "AWS Products",
      "aws-stress-level": "Team Stress Level"
    },
    "hint": {
      "dangerRatingReference": "Reference values for a danger rating distribution over different seasons, shown in grey",
      "dateChange": "After changing the date, the 'Load data' button must be pressed."
    }
  },
  "zodForm": {
    "valid": "Valid",
    "required": "Required",
    "invalidNumber": "Please enter a valid number."
  }
}
